import { ISnack } from '../props/Snack';

export const EMPTY_STATE: ISnack = {
  message: '',
  duration: undefined,
  action: undefined,
  severity: undefined,
  position: undefined,
};
